import { render, staticRenderFns } from "./Shoppingcart.vue?vue&type=template&id=53826133"
import script from "./Shoppingcart.vue?vue&type=script&lang=js"
export * from "./Shoppingcart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports